<template>

    <div class="rounded-lg bg-gray-50">

        <div class="flex flex-wrap justify-between pt-5 gap-5">
            <div
                class="flex items-center justify-between sm:w-full md:w-[48%] bg-white rounded-[20px] p-5 border border-[#D0D5DD]">
                <div>
                    <div class="text-[#101828] text-2xl font-bold">{{ part_percentage }}%</div>
                    <span class="text-[#667085] text-xs font-medium">Part 4 Progress</span>
                </div>

                <!-- Bar Graph -->
                <div class="flex gap-[2px] overflow-hidden">
                    <div v-for="(bar, index) in totalBars" :key="index">
                        <div v-if="index < filledBars" class="w-[5px] min-h-[40px] md:h-[50px] bg-[#0A0446] rounded-full"></div>
                        <div v-else class="w-[5px] min-h-[40px] md:h-[50px] bg-gray-300 rounded-full"></div>
                    </div>
                </div>
            </div>

            <div
                class="flex items-center justify-between sm:w-full md:w-[48%] bg-white rounded-[20px] p-5 border border-[#D0D5DD]">
                <div>
                    <div class="text-[#101828] text-2xl font-bold">{{ overallPercentUser }}%</div>
                    <span class="text-[#667085] text-xs font-medium">Overall Performance</span>
                </div>

                <!-- Bar Graph -->
                <div class="flex gap-[2px] overflow-hidden">
                    <div v-for="(bar, index) in totalBars" :key="index">
                        <div v-if="index < filledBarsOverallPercentage"
                            class="w-[5px] min-h-[40px] md:h-[50px] bg-[#0A0446] rounded-full"></div>
                        <div v-else class="w-[5px] min-h-[40px] md:h-[50px] bg-gray-300 rounded-full"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex flex-col gap-5 bg-white rounded-[20px] p-5 border border-[#D0D5DD] my-5">
            <div class="">
                <h1 class="text-xl font-bold mb-2 text-[#101828]">{{ section3.title }}</h1>
                <p class="text-sm font-normal text-[#101828] mx-auto" v-html="section3.description">
                </p>
            </div>

            <div>
                <h2 class="text-base font-bold mb-3 text-[#101828]">My Learnings</h2>

                <div class="flex overflow-x-auto space-x-3 pb-2 srolstyle">
                    <div class="bg-[#fcfcfd] rounded-[16px] overflow-hidden border border-[#D0D5DD] flex-none w-80"
                        v-for="img in learningPlan" v-bind:key="img.id">
                        <router-link :to="'/employer/my-learning-plan/'+img.id" class="text-white hover:text-[#ab064e]">
                        <div class="p-2">
                            <div class="mb-2">
                                <img alt="img" :src="learningPlanPath + '/' + img.image" class="w-full rounded-[8px]">
                            </div>
                            <h2 class="text-xs font-semibold text-[#101828] mb-1">{{ img.title | truncate(30) }}</h2>
                            <p class="text-xs font-normal text-[#667085] line-clamp-3 mb-2"
                                v-html="img.description.replace(/<\/?[^>]+(>|$)/g, '').slice(0, 100)">
                            </p>
                        </div>
                        </router-link>
                    </div>
                </div>

            </div>

        </div>

        <div class="flex flex-col gap-5 bg-white rounded-[20px] p-5 border border-[#D0D5DD] my-5">

            <div>
                <h1 class="text-xl font-bold mb-3 text-[#101828]">Personalized Tips</h1>
                <div class="flex overflow-x-auto space-x-3 pb-2 srolstyle" v-if="personalizedTipsList.length">
                    <div class="rounded-[16px] overflow-hidden border border-[#D0D5DD] flex-none w-80 bg-[#fcfcfd]"
                        v-for="pt in personalizedTipsList" v-bind:key="pt.id">
                        <div class="p-4">
                            <div class="mb-2">
                                <img alt="img" :src="require('@/assets/images/mpactFavicon.png')" class="rounded-full">
                            </div>
                            <h2 class="text-sm font-semibold text-[#101828] mb-1">{{ pt.title }}</h2>
                            <p class="text-xs font-normal text-[#667085]">
                                {{ pt.description }}
                            </p>
                            <span class="text-[10px] font-normal text-[#667085]">{{ pt.created_at | fromNow }}</span>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <div class="flex flex-col gap-5 bg-white rounded-[20px] p-5 border border-[#D0D5DD] my-5">

            <div>
                <h1 class="text-xl font-bold mb-1 text-[#101828]">To Do</h1>
                <p class="text-sm font-normal text-[#101828] mx-auto mb-4">
                    Step-by-step guidance to support your journey on the platform.
                </p>
                <div class="flex overflow-x-auto space-x-3 pb-2 srolstyle">
                    <div class="rounded-[16px] overflow-hidden border border-[#D0D5DD] flex-none w-2/5 bg-[#fcfcfd]"
                        v-if="todoList.length" v-for="(todo, index) in todoList" v-bind:key="todo.id">
                        <div class="p-4">
                            <div
                                class="mb-2 pb-2 border border-l-0 border-r-0 border-t-0 border-b-1 border-[#D0D5DD] flex justify-between items-center">
                                <div class="flex items-center gap-2">
                                    <span
                                        class="border border-[#D0D5DD] rounded-full p-1 w-[32px] h-[32px] flex items-center justify-center"><i
                                            class="ti ti-clipboard-text"></i></span>
                                    <span class="text-sm font-semibold text-[#101828]">{{ todo.title | truncate(15)
                                        }}</span>
                                </div>
                                <span
                                    class="text-[10px] font-medium text-[#278e63] px-3 py-1 border border-green-300 rounded-full bg-[#ecfdf3]">{{
                                    todo.status }}</span>
                            </div>
                            <div class="">
                                <!-- <h2 class="text-xs font-semibold text-[#101828] mb-1">Welcome Back:</h2> -->
                                <p class="text-xs font-normal text-[#667085] mb-2 leading-[1.6] space-y-2" v-html="sanitizedDescription(todo)"></p>
                            </div>

                        </div>
                    </div>



                </div>
            </div>

        </div>
    </div>
</template>
<script type="text/javascript">

import Api from '../../../router/api';
export default {
    props: {
        todoList: {},
        personalizedTipsList: {},
        learningPlan: {},
        section3: {},
        currentUrl: {},
        learningPlanPath: {},
        truncateParagraph: Function,
        part_percentage: 0,
        overallPercentUser: 0
    },
    data() {
        return {
            totalBars: 30,
        };
    },
    methods: {
        beforeNavigate(w, type) {
            Api.updateLearningPlanView({
                plan_id: w.id,
                part: w.part,
                type: w.link ? "2" : "1",
            });
            console.log(w);
        },
        sanitizedDescription(todo) {
            if (!todo.description) return "";

            let cleanHTML = todo.description;

            // Remove inline styles
            cleanHTML = cleanHTML.replace(/ style="[^"]*"/g, "");

            // Remove empty <p> tags
            cleanHTML = cleanHTML.replace(/<p>\s*<\/p>/g, "");

            // Fix nested <p> issue by replacing </p><p> with <br> (keeps line breaks)
            cleanHTML = cleanHTML.replace(/<\/p>\s*<p>/g, "<br><br>");

            // Ensure lists have proper spacing
            cleanHTML = cleanHTML.replace(/<\/li>\s*<li>/g, "</li><br><li>");

            // Remove unwanted tags but keep safe tags
            cleanHTML = cleanHTML.replace(/<(?!\/?(p|ul|li|strong|em|br)\b)[^>]+>/g, "");

            return cleanHTML;
        }
    },
    computed: {
        filledBarsOverallPercentage() {
            // Calculate the number of blue bars based on the percentage
            return Math.round((this.overallPercentUser / 100) * this.totalBars);
        },
        filledBars() {
            console.log('part-percent', this.part_percentage);
            // Calculate the number of blue bars based on the percentage
            return Math.round((this.part_percentage / 100) * this.totalBars);
        },
    },
    mounted() {
        setTimeout(() => {
            // Function to initialize doughnut charts
            const initializeDoughnutChart = (chartId) => {
                if (document.getElementById(chartId)) {
                    if (chartId == "chartDoughnut1") {
                        console.log({ configDoughnut })
                        configDoughnut.data = {
                            datasets: [{
                                data: [this.overallPercentUser, 100 - this.overallPercentUser],
                                backgroundColor: ["rgb(9, 4, 70)", "#ddd"],
                                borderRadius: 20,
                                borderWidth: 1,
                                hoverOffset: 2,
                                borderSkipped: false,
                            }],
                        };
                        new Chart(document.getElementById(chartId), configDoughnut);
                    } else {
                        new Chart(document.getElementById(chartId), configDoughnut);
                    }

                }
            };

            const value = 70;
            const dataDoughnut = {
                datasets: [{
                    data: [value, 100 - value],
                    backgroundColor: ["rgb(9, 4, 70)", "#ddd"],
                    borderRadius: 20,
                    borderWidth: 1,
                    hoverOffset: 2,
                    borderSkipped: false,
                },],
            };

            const configDoughnut = {
                type: "doughnut",
                data: dataDoughnut,
                options: {
                    cutout: "80%",
                    reduceXLabels: true,
                    responsive: true,
                    rotation: -125,
                    circumference: 250,
                },
            };

            // Array of chart IDs
            const doughnutChartIds = ["chartDoughnut1", "chartDoughnut2", "chartDoughnut3", "chartDoughnut4"];

            doughnutChartIds.forEach((chartId) => {
                initializeDoughnutChart(chartId);
            });

            const labels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            const data = {
                labels: labels,
                datasets: [{
                    label: "Hours",
                    display: false,
                    backgroundColor: "#0A0446",
                    borderColor: "#0A0446",
                    data: [2, 4, 2, 6, 5, 5, 3],
                },],
            };

            const configLineChart = {
                type: "line",
                data,
                options: {
                    plugins: {
                        legend: {
                            display: false,
                        },
                    },
                    responsive: true,
                },
            };

            if (document.getElementById("chartLine-new")) {
                new Chart(document.getElementById("chartLine-new"), configLineChart);
            }

            var swiper = new Swiper(".mySwiper", {
                slidesPerView: 2,
                spaceBetween: 30,
                freeMode: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }, 2000);

    }
    // Your methods to fetch and set file content should be here
};
</script>


// WEBPACK FOOTER //
// src/components/employee/dashboard/part4.vue